import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './editorTheme.css';

const TextEditorAll = ({ value, setValue,p_height= '50vh', editorKey }) => {
   const handleChange = (_content, _delta, _source, editor) => {
    setValue((prev) => ({ ...prev, [editorKey]: editor.getHTML() }));
  };
  
    const modules = {
      toolbar: [
        [{ 'header': [] }, { 'font': [] }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
        ['link'],
        ['clean']                                         
      ],
    };
  
    const formats = [
      'header', 'font', 'list', 'bullet',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'color', 'background', 'align',
      'link'
    ];
  
    
  
    return (
        <div className="rp-quill" style={{ "--editor-height": p_height }}>
        <ReactQuill
          className="pb-2"
          value={value || ""}
          onChange={handleChange}
          modules={modules}
          formats={formats}
        />
        </div>
    );
  };
  
  export default TextEditorAll;